import { purchaseBudgetArr } from '@/utils/default-data.js';
import { changeSkin } from '@/utils/common.js';
export default {
  props: {
    activeItem: {
      type: Number,
      default: 1
    },
    projectList: {
      type: Array,
      default: function () {
        return [];
      }
    }
  },
  components: {
  },
  data() {
    return {
      typeList: [],
      modeList: [],
      areaList: [],
      purchaseBudgetArr: purchaseBudgetArr,
      form: {
        city: '1406',
        projectType: 1,
        purchaseBudget: '',
        key: '',
        status: [50]
      },
      rules: {},
      search: {
        project: '',
        transaction: ''
      },
      projectTypeList: [],
      transactionTypeList: []
    };
  },
  created() {
  },
  methods: {
    changeSkin,
    searchAction() {
      this.$emit('searchAction', this.form);
    }
  }
};
